import React, { Component } from "react";
import "./Toast.css";

export default class Toast extends Component {
    render() {
        return <div id="toast">{this.props.msg}</div>;
    }
}
